// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"numbers-circle-3"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"currentColor","stroke-linecap":"square","stroke-width":2},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9.32353 7.5H15.0882V8.57143L10.9706 11.0714V11.7857H12.2059C14.0252 11.7857 15.5 13.0649 15.5 14.6429C15.5 16.2208 14.0252 17.5 12.2059 17.5H11.7941C9.97483 17.5 8.5 16.2208 8.5 14.6429","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-numbers-circle-3')
export default class NumbersCircle3Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-circle-3',
    }
  }
}
